export default __webpack_public_path__ + "static/media/M_menu.2d5f14fa.svg";